import { render } from "./UnauthenticatedFooter.vue?vue&type=template&id=7c84d0ed"
const script = {}

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/parts/UnauthenticatedFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c84d0ed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c84d0ed', __exports__)) {
    console.log('reload')
    api.reload('7c84d0ed', __exports__)
  }
  
  module.hot.accept("./UnauthenticatedFooter.vue?vue&type=template&id=7c84d0ed", () => {
    console.log('re-render')
    api.rerender('7c84d0ed', render)
  })

}


export default __exports__